import Text from '~components/dumbs/Text';
import Button from '~components/dumbs/Button';
import Paper from '~components/dumbs/Paper';

import RemoveCircleIcon from '~components/svgs/RemoveCircle';
import DoubleCheckIcon from '~components/svgs/DoubleCheck';
import CloseIcon from '~components/svgs/Close';
import InfoIcon from '~components/svgs/Info';
import { BackgroundColor } from '~components/dumbs/Paper/types';

import * as styled from './styles';
import { Props } from './types';

const iconVariantMap = {
  default: <InfoIcon />,
  success: <DoubleCheckIcon />,
  error: <RemoveCircleIcon />,
};

const backgroundColorMap = {
  default: 'neutral-weak',
  success: 'success-weak',
  error: 'danger-weak',
};

function NotificationBanner({
  title,
  children,
  variant = 'default',
  customIcon,
  onDismiss,
}: Props) {
  return (
    <Paper
      color={backgroundColorMap[variant] as BackgroundColor}
      horizontalSpacing={4}
      verticalSpacing={2}
    >
      <styled.MainRow>
        <styled.IconWrapper>
          {customIcon ? customIcon : iconVariantMap[variant]}
        </styled.IconWrapper>

        <div>
          <Text variant="b400">{title}</Text>
          <div>{children}</div>
        </div>

        {onDismiss && (
          <styled.ButtonWrapper>
            <Button
              onClick={() => onDismiss()}
              variant="subtle"
              icon={<CloseIcon />}
            />
          </styled.ButtonWrapper>
        )}
      </styled.MainRow>
    </Paper>
  );
}

export default NotificationBanner;
